import {
  ClientDataTypes,
  ClientDataDetailTypes,
  CreateClientDataTypes,
  ClientSubscription,
} from './types';

import axiosInstance from 'common/services/common/instance';

export const getClientListService = async (params?: BaseFilterParams)
  : Promise<APIPaginationResponse<ClientDataTypes[]>> => {
  const res = await axiosInstance.get('clients', { params });
  return res.data;
};

export const getClientByIdService = async (id: number)
  : Promise<ClientDataDetailTypes> => {
  const res = await axiosInstance.get(`clients/${id}`);
  return res.data.data;
};

export const createClientService = async (params: CreateClientDataTypes)
  : Promise<{ id: number }> => {
  const res = await axiosInstance.post('clients', params);
  return res.data.data;
};

export const updateClientService = async (id: number, params: CreateClientDataTypes)
  : Promise<void> => {
  await axiosInstance.put(`clients/${id}`, params);
};

export const deleteClientService = async (ids: number[]): Promise<void> => {
  await axiosInstance.delete('clients', { data: { ids } });
};

export const changeStatusClientService = async (id: number, status: number)
  : Promise<void> => {
  await axiosInstance.put(`clients/${id}/update-status`, { status });
};

export const getClientSubscriptionByIdService = async (id: number)
  : Promise<ClientSubscription[]> => {
  const res = await axiosInstance.get(`clients/${id}/subscription/history`);
  return res.data.data;
};
